/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.facilities.equipment'},
});

const EquipmentItem = () => (
  <RouteLinkItem
    route="midas/settings/facilities/equipment"
    title={messages.title}
  />
);

export default EquipmentItem;
